module.exports = __webpack_public_path__ + "img/logo-light.88f43f9f.png";